import React, { useContext, useEffect, useState } from 'react';
import { i18nContext } from '@/components/pages/assessments/context/i18n.context';
import { displayContext } from '@/components/pages/assessments/context/display.context';
import Button from '@/components/Button/Button';
import SkipButton from '@/components/pages/assessments/common/SkipButton';

const QuestionYesNo = ({ question, answer, setAnswer, setQuestionComplete, previewOnly = false }) => {
  const { t } = useContext(i18nContext);
  const { css } = useContext(displayContext);
  const [value, setValue] = useState(answer);
  const [isSkipped, setIsSkipped] = useState(answer === null);
  const required = !!question.required;

  useEffect(() => {
    if (!previewOnly) {
      setQuestionComplete(isSkipped || (value !== null && value !== undefined));
      setAnswer(value);
    }
  }, [value, isSkipped, previewOnly]);

  const handleSkipClick = () => {
    if (!previewOnly) {
      setIsSkipped(true);
      setValue(null);
    }
  };

  return (
    <div className="question-input question-yes-no">
      <div className="question-option question-option-yes">
        <Button
          additionalClasses={`${css('option-selectable-btn')} text-start`}
          styles={{ width: 'full' }}
          shape="rounded"
          state={value === 'yes' ? 'selected' : 'unselected'}
          border={true}
          text={t('Yes')}
          onButtonClick={() => {
            if (!previewOnly) {
              setValue('yes');
              setIsSkipped(false);
            }
          }}
          disabled={previewOnly}
        />
      </div>
      <div className="question-option question-option-no">
        <Button
          additionalClasses={`${css('option-selectable-btn')} text-start`}
          styles={{ width: 'full' }}
          shape="rounded"
          state={value === 'no' ? 'selected' : 'unselected'}
          border={true}
          text={t('No')}
          onButtonClick={() => {
            if (!previewOnly) {
              setValue('no');
              setIsSkipped(false);
            }
          }}
          disabled={previewOnly}
        />
      </div>
      {!required && !previewOnly && <SkipButton isSkipped={isSkipped} onButtonClick={handleSkipClick} />}
    </div>
  );
};

export default QuestionYesNo;
